import React, { useState } from "react";

import { ReservoirMap } from "./mapcomponent";
// import  ReservoirGraphs  from "./mapcomponent/AllCharts";
import styled from "styled-components";
import { PreloaderSvg } from "../../preloaderSvg/PreloaderSvg";

const Container = styled.div`
  display: flex;
  height: 100vh;
`;

const MapBackground = styled.div`
  width: 100%;
  height: 100%;
  z-index: 1;
`;


export const Reservoir: React.FC = () => {
  return (
    <Container>
      <MapBackground>
        <ReservoirMap latitude={40.632559} longitude={75.293580} />
      </MapBackground>
     
    </Container>
  );
};
